import { axios } from '../../../../axios';

const getNotificationSettings = () => {
    return axios.get(`/users/notifications/setting`)
}

const updateNotificationSettings = (data) => {
    return axios.post(`/users/notifications/setting`, data)
}

export { getNotificationSettings, updateNotificationSettings };